import React, { useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import { changeNumComma } from "../../../../AdminApi/commFunc";
import { updateReportLimitCnt } from "../../../../Api/ApiLoginCheckWeb";
import { Input } from "../../../Input/Input";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import {
  CommentTargetContainer,
  ModalLabel,
} from "../../Users/UserDetail/CommentModal/TargetContainer";

interface UpdateReportLimitCntModalProps {
  closeEvent: () => void;
  confirmEvent: () => void;
}

export default function UpdateReportLimitCntModal({
  closeEvent,
  confirmEvent,
}: UpdateReportLimitCntModalProps) {
  const [cnt, setCnt] = useState("");

  return (
    <DefaultModalLayout
      isSmallModal={true}
      closeEvent={() => closeEvent()}
      confirmEvent={() => {
        updateReportLimitCnt(Number(cnt?.replaceAll(",", "")));

        closeEvent();

        confirmEvent();

        toast.success("로그인 체크 기준 횟수가 수정되었습니다.");
      }}
      modalTitle="로그인 체크 기준 횟수"
      confirmDisabled={cnt === ""}
    >
      <>
        <ModalRow>
          <ModalLabel>카운트 설정</ModalLabel>

          <CommentTargetContainer>
            <Input
              placeholder="직접 입력"
              value={cnt}
              onChange={(e) => setCnt(changeNumComma(e).toLocaleString("ko"))}
              type="text"
              inputMode="numeric"
            />
          </CommentTargetContainer>
        </ModalRow>
      </>
    </DefaultModalLayout>
  );
}
